import script from "./PlayWell.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayWell.vue?vue&type=script&setup=true&lang=ts"

import "./PlayWell.vue?vue&type=style&index=0&id=2723a242&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2723a242"]])

export default __exports__